import fetch from '@/utils/fetch'
// 获取文档内容
export function getFileContent (url) {
  return fetch({
    url: url,
    method: 'get'
  })
}
// 获取目录结构
export function getFileInfo (params = {}) {
  return fetch({
    url: '/folder/content/' + params.number,
    method: 'get',
    params: {
      disk_type: params.disk_type,
      group_number: params.group_number,
      is_rec: params.is_rec,
      category: params.category,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 获取发布的目录结构
export function getPublicFileInfo (params = {}) {
  return fetch({
    url: '/publish_folder/content/' + params.number,
    method: 'get',
    params: {
      disk_type: params.disk_type,
      group_number: params.group_number,
      is_rec: params.is_rec,
      category: params.category,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 搜索文件和文件夹
export function resourceSearch (params = {}) {
  return fetch({
    url: '/resource/search',
    method: 'get',
    params: {
      disk_type: params.disk_type,
      group_number: params.group_number,
      category: params.category,
      is_star: params.is_star,
      searchName: params.searchName,
      offset: params.offset,
      limit: params.limit,
      search_start_date: params.search_start_date,
      search_end_date: params.search_end_date,
      tag: params.tag,
      first_level_folder: params.first_level_folder
    }
  })
}
// 【新建文件夹】
export function newFolder (data) {
  return fetch({
    url: '/folder',
    method: 'post',
    data
  })
}

// 【新建文件夹 - 树目录】
export function newFolders (data) {
  return fetch({
    url: '/folder/tree',
    method: 'post',
    data
  })
}

export function rename (data) {
  return fetch({
    url: '/rename',
    method: 'post',
    data
  })
}

export function toggleStar (data) {
  return fetch({
    url: '/startag',
    method: 'post',
    data
  })
}

// 移动/复制/删除/还原文件(夹)
export function operationFileOrFolder (data) {
  return fetch({
    url: '/operationFileOrFolder',
    method: 'post',
    data
  })
}

export function send (data) {
  return fetch({
    url: '/send',
    method: 'post',
    data
  })
}

export function extend (data) {
  return fetch({
    url: '/user/extend/capacity',
    method: 'post',
    data
  })
}

export function download (data) {
  return fetch({
    url: '/download',
    method: 'post',
    data
  })
}
// 【根据名称检索】
export function check (params) {
  return fetch({
    url: '/check/' + params.number,
    method: 'get',
    params: {
      file_name: params.file_name,
      byte: params.byte,
      disk_type: params.disk_type,
      group_number: params.group_number
    }
  })
}
// 文件上传：1、获取文件上传地址
export function getFileUploadUrl (params = {}) {
  return fetch({
    url: '/file/' + params.number,
    method: 'get',
    params: {
      storage: params.storage,
      file_name: params.file_name,
      byte: params.byte,
      disk_type: params.disk_type,
      group_number: params.group_number,
      version: params.version,
      force_cover: params.force_cover,
      file_number: params.file_number,
      fingerprint: params.fingerprint
    }
  })
}
// 文件上传：2、文件上传至云存储
export function fileUpload (data) {
  return fetch({
    url: data.url,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data.formData
  })
}
// 文件上传：3、文件上传完成通知
export function fileComplete (data) {
  return fetch({
    url: '/file/complete',
    method: 'post',
    data: {
      upload_token: data.upload_token
    }
  })
}
// 文件上传：3、文件上传完成通知(编辑文件)
export function fileEditComplete (data) {
  return fetch({
    url: '/file/edit_complete',
    method: 'post',
    data: {
      file_id: data.file_id,
      upload_token: data.upload_token,
      group_number: data.group_number,
      version: data.version,
      force_cover: data.force_cover,
    }
  })
}
// 获取文件(夹)详情
export function fileOrFolderInfo (params = {}) {
  return fetch({
    url: '/fileOrFolder/info/' + params.number,
    method: 'get',
    params: {
      type: params.type,
      is_path: params.is_path,
      group_number: params.group_number,
    }
  })
}
// 【文件预览】
export function preview (params = {}) {
  return fetch({
    url: '/preview/' + params.number,
    method: 'get',
    params: {
      number: params.number,
      group_number: params.group_number,
    }
  })
}
// 【编辑文件】
export function edit (params = {}) {
  return fetch({
    url: '/edit/' + params.number,
    method: 'get',
    params: {
      number: params.number,
      group_number: params.group_number,
    }
  })
}
// 【新建文档】
export function createOfficeFile (data) {
  return fetch({
    url: '/file/doc',
    method: 'post',
    data
  })
}
// 提交视频转码
export function fileTranstate (data) {
  return fetch({
    url: '/file/transtate',
    method: 'post',
    data
  })
}
// 获取视频文件的转码进度
export function fileTranstateStatus (params = {}) {
  return fetch({
    url: '/file/transtate',
    method: 'get',
    params: {
      number: params.number,
      group_number: params.group_number
    }
  })
}
// 版本回退-获取可以回退的版本号
export function getFileVersions (data) {
  return fetch({
    url: '/file_version_back/get_back_versions',
    method: 'post',
    data
  })
}
// 版本回退-版本实际回退
export function setFileVersion (data) {
  return fetch({
    url: '/file_version_back/opera',
    method: 'post',
    data
  })
}
// 版本回退-下载历史版本文件
export function downloadFileVersion (data) {
  return fetch({
    url: '/file_version_back/download_back_version',
    method: 'post',
    data
  })
}
// 版本回退-删除文件历史版本
export function deleteFileVersion (data) {
  return fetch({
    url: '/file_version_back/delete_back_version',
    method: 'post',
    data
  })
}
// 版本回退-历史文件预览
export function previewFileVersion (data) {
  return fetch({
    url: '/file_version_back/preview',
    method: 'post',
    data
  })
}
// 获取复制操作的进度
export function getCopyJobProgress (data) {
  return fetch({
    url: '/search_copy_job_result',
    method: 'post',
    data
  })
}